import React from 'react';
import { SEOProductSchema } from './seo-product-schema';
import { SEOText } from './seo-text';

type SEOBlockProps = {
	seoTextStyles?: string;
};

export const SEOBlock = ({ seoTextStyles = '' }: SEOBlockProps) => (
	<div>
		<SEOProductSchema />
		<SEOText className={seoTextStyles} />
	</div>
);
